/**
 * @author: lv.chen3
 * @desc: Show all items、Fold all items按钮
 * @date: 2025/2/22
 */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

interface IToggleAllItemsProps extends IBaseProps {
  isShowAll: boolean;
  onToggleIsShowAll?: () => void;
}

const ToggleAllItems: React.FC<IToggleAllItemsProps> = (props) => {
  const { style, className, isShowAll, onToggleIsShowAll, isExpandAll = false } = props;

  const btnText = useMemo(() => {
    if (isShowAll) {
      return isExpandAll ? 'Fold all Change Logs' : 'Fold all Items';
    }
    return isExpandAll ? 'Expand all Change Logs' : 'Show all Items';
  }, [isExpandAll, isShowAll]);

  return (
    <Button
      style={style}
      className={classnames('dbg-toggle-all-items', className)}
      type="link"
      onClick={(e) => {
        e?.stopPropagation();
        onToggleIsShowAll?.();
      }}
    >
      {btnText}
    </Button>
  );
};

export default ToggleAllItems;
